import { useState } from 'react'

import './Communities.scss'
import { Pagination } from '@cox/core-ui8/dist/Pagination'

import { useInversionData } from '../../../hooks/useInversionData'
import ReactGrid from '../ReactGrid/ReactGrid'

const Communities = (props: any): JSX.Element => {
  const { gridItems = [] } = props
  const inversionItems = useInversionData()
  const items = inversionItems || gridItems
  const currentUrl = globalThis.location.href
  const statefromUrl = currentUrl?.split('/').slice(6, 7)[0]
    ? currentUrl?.split('/').slice(6, 7)[0].replace('.html', '')?.toUpperCase()
    : ''
  const filteredItems = items?.filter(
    (item: { address_state: string }) => item.address_state?.toUpperCase() === statefromUrl
  )
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(12)

  // Calculate indexes for slicing
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredItems?.slice(indexOfFirstItem, indexOfLastItem)

  // Calculate total pages
  const pageCount = Math.ceil(items?.length / itemsPerPage)

  // Set current page based on click
  const pageClick = (number: any) => {
    setCurrentPage(number)
  }

  return (
    <div className={`communities container`}>
      {/* Render currentItems in the grid here */}
      <ReactGrid items={currentItems} />
      {/* Pagination List */}
      <Pagination totalPages={pageCount} pageClick={pageClick} />
    </div>
  )
}
export default Communities
